<template>
  <div class="footer-wrap-section">
    <footer>
      <div class="container">
        <div class="footer-wrap">
          <div class="footer-content">
            <div class="logo-wrap">
              <img src="@/assets/top-notch-logo.png" alt="logo" />
            </div>
            <div class="address"></div>
          </div>
          <div class="footer-content">
            <div class="head">
              INFORMATION
            </div>
            <ul class="links-list">
              <li>
                <a :href="`mailto:${footerSiteData.email}`" >{{`Email- ${footerSiteData.email === undefined || footerSiteData.email === ''? '' : footerSiteData.email}`}}</a>
              </li>
              <li>
                <a :href="`tel:${footerSiteData.phone}`" >{{`Phone- ${footerSiteData.phone === undefined || footerSiteData.phone === ''? '':footerSiteData.phone }`}}</a>
              </li>
              <li>
                <a href="#" >{{`Address- ${footerSiteData.address === undefined || footerSiteData.address === '' ? '' : footerSiteData.address}`}}</a>
              </li>
            </ul>
          </div>
          <div
            class="footer-content"
            v-for="(item, index) in MenuList"
            :key="index"
          >
            <div class="head">
              {{ item.title }}
            </div>
            <ul class="links-list">
              <li :key="i" v-for="(menu, i) in item.menu">
                <router-link :to="menu.link">{{ menu.text }}</router-link>
              </li>
            </ul>
          </div>
          <div class="footer-content">
            <div class="logo-wrap">
              <img
                class="patent-logo-image"
                src="@/assets/patentLogo.png"
                alt="logo"
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
    <div class="copyright-content">
      <div class="container">
        <div class="copyright-wrap row">
          <div class="copyright-text col-md-7 col-xs-12">
            Copyright © {{ currentYear }} Top Notch Athletes . Designed and Developed by <a class="footer-link"
             href="https://podamibenepal.com" title="https://podamibenepal.com" target="_blank" rel="noopener noreferrer">Podamibe Nepal Pvt. Ltd</a>
          </div>
          <div class="col-md-5 col-xs-12">
            <a
              class="color-white"
              :href="footerSiteData.facebook"
              target="_blank"
              v-if="footerSiteData.facebook === null || footerSiteData.facebook === '' ? false : true"
            >
              <i
                class="fa fa-facebook pointer-hover"
                style="padding: 10px;"
              ></i>
            </a>
            <a
              class="color-white"
              :href="footerSiteData.twitter"
              target="_blank"
              v-if="footerSiteData.twitter === null || footerSiteData.twitter === '' ? false : true"
            >
              <i class="fa fa-twitter pointer-hover" style="padding: 10px;"></i
            ></a>
            <a
              class="color-white"
              :href="footerSiteData.youtube"
              target="_blank"
              v-if="footerSiteData.youtube === null || footerSiteData.youtube === '' ? false : true"
            >
              <i class="fa fa-youtube pointer-hover" style="padding: 10px;"></i
            ></a>
            <a
              class="color-white"
              :href="footerSiteData.instagram"
              target="_blank"
              v-if="footerSiteData.instagram === null || footerSiteData.instagram === '' ? false : true"
            >
              <i
                class="fa fa-instagram pointer-hover"
                style="padding: 10px;"
              ></i
            ></a>
            <a
              class="color-white"
              :href="footerSiteData.linkedin"
              target="_blank"
              v-if="footerSiteData.linkedin === null || footerSiteData.linkedin === '' ? false : true"
            >
              <i
                class="fa fa-linkedin pointer-hover"
                style="padding: 10px;"
              ></i
            ></a>
            <a
              class="color-white"
              :href="footerSiteData.flickr"
              target="_blank"
              v-if="footerSiteData.flickr === null || footerSiteData.flickr === '' ? false : true"
            >
              <i
                class="fa fa-flickr pointer-hover"
                style="padding: 10px;"
              ></i
            ></a>
            <a
              class="color-white"
              :href="footerSiteData.podcast"
              target="_blank"
              v-if="footerSiteData.podcast === null || footerSiteData.podcast === '' ? false : true"
            >
              <i
                class="fa fa-podcast pointer-hover"
                style="padding: 10px;"
              ></i
            ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
const UserRepository = RepositoryFactory.get("footer");

export default {
  name: "Footer",
  data() {
    return {
      currentYear: new Date().getFullYear(),
      footerSiteData: '',
      MenuList: [
        {
          title: "Quick links",
          menu: [
            {
              link: "/about",
              text: "About Us"
            },
            {
              link: localStorage["profile-id"]
                ? `/${localStorage["profile-id"]}/privacy-policy`
                : "/privacy-policy",
              text: "Privacy Policy"
            },
            {
              link: localStorage["profile-id"]
                ? `/${localStorage["profile-id"]}/terms-and-conditions`
                : "/terms-and-conditions",
              text: "Terms & Conditions"
            },
            {
              link: localStorage["profile-id"]
                ? `/${localStorage["profile-id"]}/contact`
                : "/contact",
              text: "Contact Us"
            }
          ]
        }
        // {
        //   title: "Follow Us",
        //   menu: [
        //     {
        //       link: "#",
        //       text: "Facebook"
        //     },
        //     {
        //       link: "#",
        //       text: "Twitter"
        //     },
        //     {
        //       link: "#",
        //       text: "Instagram"
        //     },
        //     {
        //       link: "#",
        //       text: "Youtube"
        //     }
        //   ]
        // }
      ]
    };
  },
  mounted(){
    UserRepository.footerInfo()
    .then(res =>{
      const {data} =  res;
      this.footerSiteData = data;
    })
  },
  methods: {
    getDate() {
      let d = new Date();
      return `${d.getUTCFullYear()}`;
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/_variable.scss";
@import "@/scss/_mixins.scss";
.footer-wrap-section {
  background: #bf2c28;
  @media (max-width: 585px) {
    margin: 70px 0 0 0;
  }
  .footer-wrap {
    display: flex;
    flex-wrap: wrap;
    padding: 30px 0 30px;
    .footer-content {
      width: 25%;
      padding: 0 20px;
      .logo-wrap {
        @media (max-width: 500px) {
          display: none;
        }
        .patent-logo-image {
          height: 150px;
          box-shadow: none;
        }
        img {
          width: 200px;
        }
      }
      .address {
        margin-top: 20px;
        p {
          font-family: $content-font;
          color: #ffffff;
          font-size: 14px;
          font-weight: 400;
          margin-bottom: 0px !important;
        }
      }
      .head {
        font-family: $content-font;
        color: #ffffff;
        text-transform: uppercase;
        font-size: 16px;
        letter-spacing: 1px;
        font-weight: 500;
        margin-bottom: 20px;
      }
      .links-list {
        margin: 0;
        padding: 0;
        list-style: none;
        li {
          padding: 5px 0;
          a {
            font-family: $content-font;
            color: #ffffff;
            text-transform: capitalize;
            letter-spacing: 0.5px;
            font-size: 14px;
            font-weight: 300;
          }
          &:first-child {
            padding-top: 0;
          }
          &:last-child {
            padding-bottom: 0;
          }
        }
      }
      &:first-child {
        padding-left: 0;
      }
      &:last-child {
        padding-right: 0;
      }
    }
  }
  .copyright-content {
    padding: 10px 0 10px;
    border-top: 1px solid #fff;
    .copyright-wrap {
      font-family: $content-font;
      font-size: 16px;
      text-align: center;
      color: #ffffff;
        display: flex;
        justify-content:center;
        align-items: center;
      .copyright-text {
        text-align: left;
        font-size: 14px;
      }
    }
  }
}

@media only screen and (min-width: 576px) and (max-width: 767px) {
  .footer-wrap-section {
    .footer-wrap {
      .footer-content {
        .address {
          p {
            font-size: 12px;
            line-height: 20px;
          }
        }
        .head {
          font-size: 14px;
          margin-bottom: 15px;
        }
        .links-list {
          li {
            padding: 3px 0;
            a {
              font-size: 12px;
            }
          }
        }
      }
    }
    .copyright-content {
      padding: 20px 0 20px;
      .copyright-wrap {
        font-size: 14px;
      }
    }
  }
}

@media only screen and (max-width: 575px) {
  .footer-wrap-section {
    .footer-wrap {
      padding-bottom: 0px;
      .footer-content {
        width: 100%;
        text-align: center;
        margin-bottom: 40px;
        padding: 0 10px !important;
        .logo-wrap {
          .patent-logo-image {
            height: auto;
          }
          img {
            max-width: 125px;
            margin: 0 auto;
          }
        }
        .head {
          margin-bottom: 15px;
        }
      }
    }
    .copyright-content {
      padding: 20px 0 20px;
      .copyright-wrap {
        font-size: 12px;
      }
    }
  }
}
.footer-link{
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
  &:hover{
    color: #272E7F;
  }
}
</style>
